// extracted by mini-css-extract-plugin
export default {"acceptTerms":"acceptTerms__IADbFMRRm5sD","footer":"footer__oyezMKfT9lI3","passwordRequirements":"passwordRequirements___ybrsFvxI46S"};